export { default as PrimaryNavTooltipMenuTab } from './PrimaryNavTooltipMenuTab';
